import { Box } from '@mui/material'

/** Small “Beta” mark for private / unreleased surfaces. */
export default function BetaTag({ size = 'nav' }: { size?: 'nav' | 'page' }) {
  const compact = size === 'nav'
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        height: compact ? 16 : 22,
        px: compact ? 0.6 : 1,
        borderRadius: 'var(--radius-pill)',
        border: '1px solid var(--vs-border)',
        bgcolor: 'var(--vs-accent-wash)',
        color: 'var(--vs-link)',
        fontSize: compact ? '0.625rem' : '0.75rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        lineHeight: 1,
        textTransform: 'uppercase',
      }}
    >
      Beta
    </Box>
  )
}
